import PaymentProcessing from '@cont/Checkout/PaymentProcessing';
import Layout from '@layout/PaymentLayout/PaymentLayout';
import setupInitialProps from '@utils/setupInitialProps';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const PaymentResponsePage = () => {
  return <PaymentProcessing />;
};

PaymentResponsePage.Layout = Layout;

PaymentResponsePage.pageInfo = {
  isMWebSupported: true,
  layoutOptions: {
    isCheckoutUrl: true,
    hideFooter: true,
    disableDarkMode: true,
    hideIntercom: true,
    hideFreshbot: true
  }
};

PaymentResponsePage.getInitialProps = setupInitialProps(
  null,
  PaymentResponsePage.pageInfo
);

export default PaymentResponsePage;
PaymentResponsePage.Wrapper = PageReduxProvider;
